// extracted by mini-css-extract-plugin
module.exports = {"h4":"paymentMethodsList_h4__rAXVe","ctaTitle":"paymentMethodsList_ctaTitle__QsMRB"};